module.exports = __webpack_public_path__ + "static/media/installation.ccf02986.jpg";